// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel_3AGh7","logoWrapper":"Panel_logoWrapper_FsDpx","logo":"Panel_logo_1tqmL","divName":"Panel_divName_2ub3A typography_standard_3NYy8"};